import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { Modal, Button } from 'antd'
import { inject, observer } from "mobx-react"
import styled from 'styled-components'
import { observable } from 'mobx'

const ModalWrapper = styled(Modal)`
  .ant-modal-body {
    padding: 0 16px 10px 16px;
  }
  .ant-modal-footer {
    display: flex;
    justify-content: center;
  }
`
const ContentWrapper = styled.div`
  padding: 10px;
`
const ContentItem = styled.p`
  margin-bottom: 20px;
  font-size: 14px;
  word-wrap: break-word;
`
const Title = styled.div`
  padding: 0 10px;
  font-size: 16px;
`
const KnowBtn = styled(Button)`
  &.know {
    font-size: 14px !important;
  }
  &.disabled {
    font-size: 14px !important;
    background: #eee !important;
  }
`

@inject("auth") @observer
class NoticeInfoModal extends Component {
  @observable countDown = 10
  @observable clickable = false

  constructor(props) {
    super(props)
    this.handleCountDown()
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  render() {
    const { onClose, onceShow, selectedNotice } = this.props
    const splitCotentArray = selectedNotice.content.split("\n")
    return (
      <ModalWrapper
        title={<Title>{selectedNotice.title}</Title>}
        visible
        maskClosable={false}
        onCancel={() => onceShow ? null : onClose()}
        width={720}
        footer={onceShow ?
          this.clickable ?
            <KnowBtn
              className="know"
              type="primary"
              onClick={this.clickKnowBtn}
            >
              我已知晓
            </KnowBtn> :
            <KnowBtn
              className="disabled"
              disabled
            >
              {this.countDown}s后可以关闭
            </KnowBtn> : null}
      >
        <ContentWrapper>
          {splitCotentArray && splitCotentArray.map((item, index) => (
            <ContentItem key={index}>{item}</ContentItem>
          ))}
        </ContentWrapper>
      </ModalWrapper>
    )
  }

  handleCountDown = () => {
    this.timer = setInterval(() => {
      if (this.countDown === 0) {
        clearInterval(this.timer)
        this.clickable = true
      } else {
        this.countDown -= 1
      }
    }, 1000)
  }

  clickKnowBtn = () => {
    const { selectedNotice, onClose } = this.props
    const { changeNoticeState } = this.props.auth
    changeNoticeState(selectedNotice.noticeId)
      .then(res => {
        onClose()
      })
  }
}

NoticeInfoModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  selectedNotice: PropTypes.object.isRequired
}

export default NoticeInfoModal



// WEBPACK FOOTER //
// ./src/app/components/normal/NoticeInfoModal/index.js